import {} from "../mod/index.js";
import { findInputPorts } from "../net/findInputPorts.js";
import { findOutputPorts } from "../net/findOutputPorts.js";
import {} from "../net/index.js";
import {} from "../node/index.js";
import { capInputPort } from "./capInputPort.js";
import { capOutputPort } from "./capOutputPort.js";
export function capNodeNonPrinciplePorts(mod, net, node) {
    for (const port of findInputPorts(net, node)) {
        if (!port.isPrincipal) {
            capInputPort(mod, net, port);
        }
    }
    for (const port of findOutputPorts(net, node)) {
        if (!port.isPrincipal) {
            capOutputPort(mod, net, port);
        }
    }
}
//# sourceMappingURL=capNodeNonPrinciplePorts.js.map